import Cookies from 'js-cookie'

function menuGet(key){
  var url = window.location.href
  var pathPrefix = process.env.PREFIXES
  if (url.indexOf('shopadmin') !== -1) {
    key = key + pathPrefix + '/shopadmin'
  } else {
    key = key + pathPrefix
  }
  return JSON.parse(localStorage.getItem(key))
}

const menu = {
  state: {
    menus: menuGet('menu'),
    wheight: localStorage.getItem('wheight')
  },

  mutations: {
    setMenu: (state, menu) => {
      state.menus = menu
      var key = 'menu'
      var url = window.location.href
      var pathPrefix = process.env.PREFIXES
      if (url.indexOf('shopadmin') !== -1) {
        key = key + pathPrefix + '/shopadmin'
      } else {
        key = key + pathPrefix
      }
      localStorage.setItem(key,JSON.stringify(menu));
    },
    setHeight: (state, height) => {
      state.wheight = height
      localStorage.setItem('wheight', height);
    }
  },

  actions: {
    setMenu ({commit}, menu) {
      commit('setMenu', menu)
    },
    setHeight ({commit}, height) {
      commit('setHeight', height)
    }
  },

  getters: {
    menus(state) {
      return state.menus;
    },
    wheight(state) {
      return state.wheight;
    }
  },
};

export default menu;



// WEBPACK FOOTER //
// ./src/store/modules/menu.js